"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GuildLevel = exports.GuildRole = void 0;
var GuildRole;
(function (GuildRole) {
    GuildRole[GuildRole["Owner"] = 10] = "Owner";
    GuildRole[GuildRole["Administrator"] = 5] = "Administrator";
    GuildRole[GuildRole["Member"] = 3] = "Member";
    GuildRole[GuildRole["Invited"] = 0] = "Invited";
})(GuildRole || (exports.GuildRole = GuildRole = {}));
var GuildLevel;
(function (GuildLevel) {
    GuildLevel[GuildLevel["HasGuildHall"] = 1] = "HasGuildHall";
    GuildLevel[GuildLevel["Basic"] = 0] = "Basic";
})(GuildLevel || (exports.GuildLevel = GuildLevel = {}));
